import React from "react";
import { createColumnHelper } from "@tanstack/react-table";

import { PencilSimpleLineIcon, SketchLogoIcon } from "@phosphor-icons/react";
import Icon from "components/Icon/Icon";

import CommonTooltip from "components/Tooltip/index";

import {
  CompanyNameCell,
  getFullName,
  getUserPlaceholder,
  renderValue
} from "utils/renderCompanyCell";
import { format } from "date-fns";
import CreatorUserDropdown from "./components/CreatorUserDropdown";
import StatusPillButtons from "components/Buttons/StatusPillButtons";

const columns = (navigate, searchParams, onViewSubscription) => {
  const columnHelper = createColumnHelper();

  const renderName = (row) => {
    const fullName = renderValue(getFullName(row));
    return (
      <CompanyNameCell
        logo={row?.profile_pic || getUserPlaceholder()}
        name={fullName}
        title={fullName}
      />
    );
  };
  return [
    columnHelper.accessor("id", {
      header: "Id",
      size: 80,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("creator_id", {
      header: "Creator ID",
      size: 160,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor((row) => row.name, {
      id: "name",
      header: "Display Name",
      size: 200,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => {
        const row = info.row.original;
        return renderName(row);
      }
    }),

    columnHelper.accessor("status", {
      header: "Account Status",
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => <StatusPillButtons status={info.getValue()} />
    }),

    columnHelper.accessor("subscriptions", {
      header: "Subscription",
      size: 160,
      headerClassName: "table-header",
      enableSorting: false,
      cellClassName: "table-cell",
      cell: ({ row }) => {
        const planName = row.original.subscriptions[0]?.plan?.name;

        return <StatusPillButtons status={planName} />;
      }
    }),

    columnHelper.accessor("email", {
      header: "Email",
      size: 160,
      headerClassName: "table-header",
      enableSorting: false,
      cellClassName: "table-cell",
      cell: (info) => (
        <div className="truncate-text" title={renderValue(info.getValue())}>
          {renderValue(info.getValue())}
        </div>
      )
    }),

    columnHelper.accessor("phone_number", {
      header: "Phone",
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => <>{`+91 ${renderValue(info.getValue())}`}</>
    }),

    columnHelper.accessor("created_at", {
      header: "Created At",
      size: 207,
      headerClassName: "table-header",
      enableSorting: false,
      cellClassName: "table-cell",
      cell: (info) => (
        <>
          {renderValue(
            format(new Date(info.getValue()), "MMM dd, yyyy h:mm a")
          )}
        </>
      )
    }),
    columnHelper.accessor("profile_completion_percentage", {
      header: "Profile Complete %",
      size: 200,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => {
        const value = info.getValue();
        return <>{value !== null && value !== undefined ? `${value}%` : "-"}</>;
      }
    }),
    columnHelper.display({
      id: "actions",
      header: "Actions",
      size: 140,
      cellClassName: "actions",
      enableSorting: false,
      cell: (info) => {
        return (
          <div className="hover-btn-wrapper">
            <CommonTooltip theme="dark" tooltipContent="View Subscription">
              <div className="hover-actions">
                <Icon
                  component={SketchLogoIcon}
                  format="outline"
                  weight="regular"
                  onClick={() => onViewSubscription(info.row.original)}
                />
              </div>
            </CommonTooltip>

            <CommonTooltip theme="dark" tooltipContent="Edit Details">
              <div className="hover-actions">
                <Icon
                  component={PencilSimpleLineIcon}
                  format="outline"
                  weight="regular"
                  onClick={() =>
                    navigate(
                      `/creator-users/${info.row.original.id}?mode=view&${searchParams.toString()}`
                    )
                  }
                />
              </div>
            </CommonTooltip>
            <CreatorUserDropdown userInfo={info.row.original} />
          </div>
        );
      }
    })
  ];
};

export default columns;
